var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-overlay",class:{'bg-gray' : _vm.isGray},on:{"click":function($event){$event.stopPropagation();return _vm.handleOverlayClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }